import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="pt-40 pb-24 lg:pt-48 lg:pb-32 px-6 lg:px-12 max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-16 lg:gap-24" data-id="element-143">
      {/* Left Content */}
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="flex-1 w-full" data-id="element-144">
        <span className="block text-taupe-dark text-xs uppercase tracking-[0.3em] font-sans mb-6" data-id="element-145">
          Welcome to Parkway Esthetics
        </span>

        <h1 className="font-serif text-6xl lg:text-7xl xl:text-8xl font-light leading-tight mb-8 text-black" data-id="element-146">
          Scar <br data-id="element-147" />
          <span className="italic text-taupe-dark" data-id="element-148">Camouflage</span>
        </h1>

        <div className="flex flex-col gap-3 mb-12 font-sans text-black/80 text-lg" data-id="element-149">
          <div className="flex items-center gap-4" data-id="element-150">
            <span className="w-6 h-[1px] bg-taupe" data-id="element-151"></span>
            <span data-id="element-152">Tummy Tuck</span>
          </div>
          <div className="flex items-center gap-4" data-id="element-153">
            <span className="w-6 h-[1px] bg-taupe" data-id="element-154"></span>
            <span data-id="element-155">Breast Lift</span>
          </div>
          <div className="flex items-center gap-4" data-id="element-156">
            <span className="w-6 h-[1px] bg-taupe" data-id="element-157"></span>
            <span data-id="element-158">Lipo Scars</span>
          </div>
          <div className="flex items-center gap-4" data-id="element-159">
            <span className="w-6 h-[1px] bg-taupe" data-id="element-160"></span>
            <span data-id="element-161">Areola Correction</span>
          </div>
          <div className="flex items-center gap-4" data-id="element-162">
            <span className="w-6 h-[1px] bg-transparent" data-id="element-163"></span>
            <span className="italic text-taupe-dark" data-id="element-164">and more...</span>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4" data-id="element-165">
          <a href="#" className="bg-black text-white px-10 py-4 text-xs uppercase tracking-widest font-sans hover:bg-black/80 transition-colors text-center" data-id="element-166">
            Make an Appointment
          </a>
          <a href="#what-we-do" className="border border-black text-black px-10 py-4 text-xs uppercase tracking-widest font-sans hover:bg-black hover:text-white transition-colors text-center" data-id="element-167">
            Learn More
          </a>
        </div>
      </motion.div>

      {/* Right Image */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 1,
      ease: 'easeOut',
      delay: 0.2
    }} className="flex-1 w-full relative" data-id="element-168">
        <div className="relative aspect-[3/4] w-full max-w-md mx-auto lg:ml-auto lg:mr-0 overflow-hidden" data-id="element-169">
          <img src="https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?auto=format&fit=crop&q=80&w=1200" alt="Luxury Spa Treatment" className="w-full h-full object-cover hover:scale-105 transition-transform duration-1000" data-id="element-170" />

          {/* Badge */}
          <div className="absolute bottom-0 left-0 bg-black text-white p-6 md:p-8 max-w-[200px]" data-id="element-171">
            <span className="block font-serif text-4xl mb-2" data-id="element-172">20</span>
            <span className="block text-[10px] uppercase tracking-widest font-sans leading-relaxed" data-id="element-173">
              Years of Experience
            </span>
          </div>
        </div>

        {/* Decorative background element */}
        <div className="absolute -z-10 top-8 -right-8 w-full h-full border border-taupe/30 max-w-md hidden lg:block" data-id="element-174"></div>
      </motion.div>
    </section>;
}